module.exports = function() {
    return {
        id: null,
        epic_id: null,
        creator_id: null,
        title: "",
        description: "",
        tech_notes: "",
        test_notes: "",
        user: null
    }
}